'use client';

import { useEffect, useState } from 'react';

import { subscribeToTippingGoalDoc } from '../functions/subscribeToTippingGoalDoc';

/**
 * Overlays a live `achievedAmount` on top of the server-resolved (cached) goal
 * amount, so the visitor tipping progress bar updates the instant a tip lands
 * instead of waiting out the cache-life window — via the SAME
 * {@link subscribeToTippingGoalDoc} listener the owner editor's
 * `subscribeToTippingGoal` subscribes through. Starts from
 * `initialAchievedAmount` and switches to the live value once the subscription
 * delivers its first snapshot.
 */
export function useLiveTipGoalAmount(
  creatorId: string,
  goalId: string | undefined,
  initialAchievedAmount: number,
): number {
  const [liveAmount, setLiveAmount] = useState<number | null>(null);

  useEffect(() => {
    setLiveAmount(null);
    if (!goalId) {
      return;
    }
    return subscribeToTippingGoalDoc(
      creatorId,
      goalId,
      data => setLiveAmount((data?.achievedAmount as number) ?? 0),
      error => console.error('Failed to subscribe to tip goal amount:', error),
    );
  }, [creatorId, goalId]);

  return liveAmount ?? initialAchievedAmount;
}
